<template>
  <div class="mb-3">
    <b-card no-body >
      <b-card-header class="header-enquesta">
        <b-row>
          <b-col lg="9" md="8" sm="6"><b>{{this.initialValue.descripcio}}</b></b-col>
          <b-col lg="3" md="4" sm="6" class="btn-group-enquesta">            
              <b-button-group class="mx-1" size="sm" >
                <b-button :variant="this.activeTab=='activacions'?'primary':'outline-primary'" @click="onViewActivacionsEnquesta()"><b-icon icon="play-fill" ></b-icon></b-button>
                <b-button :variant="this.activeTab=='quotes'?'primary':'outline-primary'" @click="onViewQuotesEnquesta()"><b-icon icon="trophy"></b-icon></b-button>
                <b-button :variant="this.activeTab=='questionari'?'primary':'outline-primary'" @click="onViewQuestionariEnquesta()"><b-icon icon="list-ol"></b-icon></b-button>                
              </b-button-group>
              <b-dropdown :text="$t('btn.accions')" right variant="outline-primary" size="sm">
                <b-dropdown-item href="#" @click="onEditarEnquesta()"><b-icon icon="pencil-square" aria-label="Editar" class="mr-2"></b-icon>{{$t('btn.editar')}}</b-dropdown-item>              
                <b-dropdown-item href="#" @click="onNovaQuotaEnquesta()"><b-icon icon="trophy" aria-label="Nova quota" class="mr-2"></b-icon>Nova quota</b-dropdown-item>              
                <b-dropdown-item href="#" @click="onNovaActivacioEnquesta()"><b-icon icon="play-fill" aria-label="Nova activació" class="mr-2"></b-icon>Nova activació</b-dropdown-item>
                <!--b-dropdown-item  href="#" @click="onEliminarEnquesta()"><b-icon icon="trash" aria-label="Eliminar" class="mr-2"></b-icon>{{$t('btn.eliminar')}}</b-dropdown-item-->          
              </b-dropdown>            
          </b-col>
        </b-row>
      </b-card-header>

      <div class="accordion" role="tablist">

        <b-collapse :id="`${'collapse-quotes-'+this.initialValue.idEnquesta}`" :accordion="`${'accordion-'+this.initialValue.idEnquesta}`" role="tabpanel">
          <b-list-group flush>
            <b-list-group-item  class="titol-enquesta">
              <b-row no-gutters>
                <b-col md="4" sm="12">
                  <span class="label-titol-quota">
                    Descripció de la quota
                  </span>
                </b-col>
                <b-col md="4" sm="12">
                  <span class="label-titol-quota">
                    Objectiu
                  </span>
                </b-col>
                <b-col md="4" sm="12">
                </b-col>                   
              </b-row>
            </b-list-group-item >

            <template v-if="!showSpinnerQuotes && this.initialValue.quotes.length<1">
              <b-list-group-item style="padding-top: 2px;padding-bottom: 2px;">No hi han quotes definides.</b-list-group-item >
            </template>
            <div class="text-center mt-4" v-if="showSpinnerQuotes"><b-spinner variant="primary" ></b-spinner></div>
            <div style="padding-left: 20px;padding-right: 20px;"> 
              <template v-for="(item,idx) in initialValue.quotes">
                <ItemQuota v-bind:key='idx' v-bind:initialValue="item" mode="editar" v-on:editar-quota="onEditarQuotaEnquesta" v-on:eliminar-quota="onEliminarQuotaEnquesta"/>
              </template> 
            </div>

          </b-list-group>
      </b-collapse>

      <b-collapse :id="`${'collapse-questionari-'+this.initialValue.idEnquesta}`"  :accordion="`${'accordion-'+this.initialValue.idEnquesta}`" role="tabpanel">
        <b-list-group flush>
          <b-list-group-item >
              <p><b>{{ this.initialValue.questionari.titol | etiqueta}}</b></p>
              <p>
                  <ul>
                    <template v-for='(p) in this.initialValue.questionari.preguntes'>
                      <li v-bind:key="p.idPregunta">{{ p.enunciat | etiqueta}}</li>
                    </template>
                  </ul>
              </p> 
          </b-list-group-item >
        </b-list-group>
      </b-collapse>

      <b-collapse visible :id="`${'collapse-activacions-'+this.initialValue.idEnquesta}`"  :accordion="`${'accordion-'+this.initialValue.idEnquesta}`" role="tabpanel">
        <b-list-group flush>
          <b-list-group-item class="titol-enquesta">          
            <b-row no-gutters >
              <b-col md="3" sm="8">
                <span class="label-titol-activacio">{{$t('admin.enquestes.llistat.descripcio')}}</span>
              </b-col>
              <b-col md="2" sm="4">
                <span class="label-titol-activacio">{{$t('admin.enquestes.llistat.estat')}}</span>
              </b-col>
              <b-col md="2" sm="6">
                <span class="label-titol-activacio">{{$t('admin.enquestes.llistat.activacio')}}</span>
              </b-col>
              <b-col md="2" sm="6">
                <span class="label-titol-activacio">{{$t('admin.enquestes.llistat.expiracio')}}</span>
              </b-col>
              <b-col md="3" sm="12">
              </b-col>
            </b-row>
          </b-list-group-item>
          <template v-if="this.initialValue.activacions.length<1"> 
              <b-list-group-item style="padding-top: 2px;padding-bottom: 2px;">No hi han activacions.</b-list-group-item >
          </template>
          <template v-for="(item) in initialValue.activacions">
            <ItemActivacio v-bind:key='item.idActivacio+mountedTime' v-if="!item.filtered" v-bind:initialValue="item"
            v-on:editar-activacio="onEditarActivacioEnquesta" 
            v-on:eliminar-activacio="onEliminarActivacioEnquesta"
            v-on:assignar-activacio="onAssignarActivacioEnquesta"
            v-on:activar-activacio="onActivarActivacioEnquesta"
            v-on:detalls-activacio="onDetallsActivacioEnquesta"
            v-on:consultar-resultats="onConsultarResultats"
            v-on:exportar-resultats="onExportarResultats"
            />         
          </template>          
        </b-list-group>
      </b-collapse>

      </div>

    </b-card>
    
  </div>
</template>

<script>
import questionariService from "../../services/QuestionariService";
import quotaService from "@/services/QuotaService";
import ItemActivacio from './ItemActivacio.vue';
import ItemQuota from './ItemQuota.vue';
export default {
  name: "ItemEnquesta",
  components: {
    ItemActivacio,ItemQuota
  },  
  props: {    
     initialValue:{      
      type: Object,
      required: true
    }
  },   
  data() {
    return {enquesta: {},activeTab:null,mountedTime:null, showSpinnerQuotes:true};
  },
  computed:{
  },   
  methods: {    
    onEditarEnquesta(){
      this.$emit('editar-enquesta', this.initialValue);
    },
    onEliminarEnquesta(){
      this.$emit('eliminar-enquesta', this.initialValue);
    },
    onViewQuotesEnquesta(){
      this.initQuotesEnquesta();
      this.$root.$emit('bv::toggle::collapse', 'collapse-quotes-'+this.initialValue.idEnquesta)
      if(this.activeTab != "quotes"){
        this.activeTab = "quotes";
      }else{
        this.activeTab = "";
      }
    },
    async initQuotesEnquesta(){
      try{
        this.showSpinnerQuotes=true
        this.initialValue.quotes = new Array();
        const response = await quotaService.listQuotaByIdEnquesta(this.initialValue.idEnquesta);
        this.initialValue.quotes.push(...response.data);
        this.showSpinnerQuotes = false;
      }catch(e){
        console.log(e);
      }
    },
    onViewQuestionariEnquesta(){
      if(this.initialValue.questionari && this.initialValue.questionari.preguntes){
        this.$root.$emit('bv::toggle::collapse', 'collapse-questionari-'+this.initialValue.idEnquesta);
        if(this.activeTab != "questionari"){
          this.activeTab = "questionari";
        }else{
          this.activeTab = "";
        }
      }else{
          
        questionariService.getQuestionari(this.initialValue.questionari.idQuestionari).then(response => {        
          if(response.status == 200){
            this.initialValue.questionari = response.data;            
            this.$root.$emit('bv::toggle::collapse', 'collapse-questionari-'+this.initialValue.idEnquesta);
            if(this.activeTab != "questionari"){
              this.activeTab = "questionari";
            }else{
              this.activeTab = "";
            }
          }
        }).catch(e => {
            console.log(e);
        });


      }      
    },
    onViewActivacionsEnquesta(){
      this.$root.$emit('bv::toggle::collapse', 'collapse-activacions-'+this.initialValue.idEnquesta)
        if(this.activeTab != "activacions"){
          this.activeTab = "activacions";
        }else{
          this.activeTab = "";
        }      
    },
    onNovaQuotaEnquesta(){       
      this.$emit('editar-quota', {idEnquesta:this.initialValue.idEnquesta});
    },
    onEditarQuotaEnquesta(data) {
      this.$emit('editar-quota', data);
    },
    onEliminarQuotaEnquesta(data){
      this.$emit('eliminar-quota', data);
    },
    onNovaActivacioEnquesta(){       
      this.$emit('editar-activacio', {idEnquesta:this.initialValue.idEnquesta});
    },
    onEditarActivacioEnquesta(data){       
      this.$emit('editar-activacio', data);
    },
    onEliminarActivacioEnquesta(data){
      this.$emit('eliminar-activacio', data);
    },
    onAssignarActivacioEnquesta(data){
      this.$emit('assignar-activacio', data);
    },
    onActivarActivacioEnquesta(data){
      this.$emit('activar-activacio', data);
    },
    onDetallsActivacioEnquesta(data){
        this.$emit('detalls-activacio', data);      
    },
    onConsultarResultats(data){ 
      data.filtres[0].idEnquesta = this.initialValue.idEnquesta;      
      this.$emit('consultar-resultats', data);
    },
    onExportarResultats(data){
      data.idEnquesta = this.initialValue.idEnquesta;        
      this.$emit('exportar-resultats', data);
    },
    onFilterEnquestesActivacions(){
      this.mountedTime = new Date().getTime();
    }                    
  },
  mounted() {
    console.log("MONTANDO ITEM_ENQUESTES")
    this.activeTab = "activacions";
    this.mountedTime = new Date().getTime();
    if(this.initialValue!=null){
      this.enquesta = this.initialValue;
    }
    this.$root.$on('filter-enquestes-activacions', this.onFilterEnquestesActivacions)
  }
};
</script>

<style>
.header-enquesta{
  padding: 0.2rem 1.25rem;
  background-color:rgba(0, 0, 0, 0.128);
}
.titol-enquesta{
  padding-top: 2px;
  padding-bottom: 2px;
  background-color:rgba(0, 0, 0, 0.068);
}
.btn-group-enquesta{
  text-align: right;
}
.label-titol-quota{
  font-weight: 500;
  font-size: 14px;
}
.label-titol-activacio{
  font-weight: 500;
  font-size: 14px;
}
</style>